import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dzis from "@/pages/Dzis";
import Podsumowanie from "@/pages/Podsumowanie";
import Status from "@/pages/Status";
import Sprzedaz from "@/pages/Sprzedaz";
import DrogaKlientki from "@/pages/DrogaKlientki";
import Landingi from "@/pages/Landingi";
import Inspiracje from "@/pages/Inspiracje";
import Komentarze from "@/pages/Komentarze";
import KomentarzeStatystyki from "@/pages/KomentarzeStatystyki";
import SocialProof from "@/pages/SocialProof";
import HistorieMessenger from "@/pages/HistorieMessenger";
import ZespolAI from "@/pages/ZespolAI";
import Kanban from "@/pages/Kanban";
import Linki from "@/pages/Linki";
import Wysylka from "@/pages/Wysylka";
import Karuzele from "@/pages/Karuzele";
import KaruzeleUstawienia from "@/pages/KaruzeleUstawienia";
import Zdjecia from "@/pages/Zdjecia";
import Elementy from "@/pages/Elementy";
import Fonty from "@/pages/Fonty";
import PlanTygodnia from "@/pages/PlanTygodnia";
import TydzienArka from "@/pages/TydzienArka";
import Subskrypcje from "@/pages/Subskrypcje";
import Mailing from "@/pages/Mailing";
import Publikacje from "@/pages/Publikacje";
import Inteligencja from "@/pages/Inteligencja";
import Rolki from "@/pages/Rolki";
import Wiedza from "@/pages/Wiedza";
import Dokumenty from "@/pages/Dokumenty";
import DokumentDetail from "@/pages/DokumentDetail";
import PrzeplywWiedzy from "@/pages/PrzeplywWiedzy";
import Bart from "@/pages/Bart";
import Barometr from "@/pages/Barometr";
import Mapy from "@/pages/Mapy";
import MapaDetail from "@/pages/MapaDetail";
import Interakcje from "@/pages/Interakcje";
import OpDemo from "@/pages/OpDemo";
import AutomatyzacjeDm from "@/pages/AutomatyzacjeDm";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dzis />} />
        <Route path="/podsumowanie" element={<Podsumowanie />} />
        <Route path="/status" element={<Status />} />
        <Route path="/sprzedaz" element={<Sprzedaz />} />
        <Route path="/droga-klientki" element={<DrogaKlientki />} />
        <Route path="/landingi" element={<Landingi />} />
        <Route path="/inspiracje" element={<Inspiracje />} />
        <Route path="/komentarze" element={<Komentarze />} />
        <Route path="/komentarze/statystyki" element={<KomentarzeStatystyki />} />
        <Route path="/komentarze/social-proof" element={<SocialProof />} />
        <Route path="/barometr" element={<Barometr />} />
        <Route path="/historie-messenger" element={<HistorieMessenger />} />
        <Route path="/zespol-ai" element={<ZespolAI />} />
        <Route path="/kanban" element={<Kanban />} />
        <Route path="/linki" element={<Linki />} />
        <Route path="/interakcje" element={<Interakcje />} />
        <Route path="/wysylka" element={<Wysylka />} />
        <Route path="/karuzele" element={<Karuzele />} />
        <Route path="/karuzele/ustawienia" element={<KaruzeleUstawienia />} />
        <Route path="/zdjecia" element={<Zdjecia />} />
        <Route path="/elementy" element={<Elementy />} />
        <Route path="/fonty" element={<Fonty />} />
        <Route path="/plan-tygodnia" element={<PlanTygodnia />} />
        <Route path="/tydzien-arka" element={<TydzienArka />} />
        <Route path="/subskrypcje" element={<Subskrypcje />} />
        <Route path="/mailing" element={<Mailing />} />
        <Route path="/automatyzacje-dm" element={<AutomatyzacjeDm />} />
        <Route path="/publikacje" element={<Publikacje />} />
        <Route path="/inteligencja" element={<Inteligencja />} />
        <Route path="/rolki" element={<Rolki />} />
        <Route path="/wiedza" element={<Wiedza />} />
        <Route path="/dokumenty" element={<Dokumenty />} />
        <Route path="/dokumenty/:id" element={<DokumentDetail />} />
        <Route path="/mapy" element={<Mapy />} />
        <Route path="/mapy/:id" element={<MapaDetail />} />
        <Route path="/przeplyw-wiedzy" element={<PrzeplywWiedzy />} />
        <Route path="/bart" element={<Bart />} />
        <Route path="/op-demo" element={<OpDemo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
